import React from 'react'
import { useLocation } from 'react-router-dom'

function DashboardIcon({ size = 28 }) {
    const location = useLocation()
    const isActive = location.pathname.startsWith('/dashboard')
    const color = isActive ? '#FFFFFF' : '#8F9DAC'

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_10301_19024)">
                <path
                    d="M4.66663 4.6665H11.6666V13.9998H4.66663V4.6665Z"
                    stroke={color}
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.66663 18.6665H11.6666V23.3332H4.66663V18.6665Z"
                    stroke={color}
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3334 14H23.3334V23.3333H16.3334V14Z"
                    stroke={color}
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3334 4.6665H23.3334V9.33317H16.3334V4.6665Z"
                    stroke={color}
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10301_19024">
                    <rect width="28" height="28" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default DashboardIcon
